export default __webpack_public_path__ + "static/media/gift.aaa57d8d.png";